import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IUserInfo } from '../../../../ts/models/IUserInfo';
import { Users } from '../../../../userManagement/services/resources/Users';
import { ChangeContentOwnerAction } from '../../../../ts/services/ChangeContentOwnerAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { SetOwnerAction } from '../../../actions/spaces/SetOwnerAction';
import { ServiceLocator } from '../../../ServiceLocator';
import { reloadSpaceIfUpdatingCurrentSpace } from '../content/RefreshContentSagas';
import { replaceDatasourceIdWithConnectionIdForMixedContent } from '../SpacesSagaHelpers';
import { IResult } from '../../../../ts/ServerApi/types/IResponse';

export function* handleSetOwner(action: SetOwnerAction): SagaIterator {

  try {
    let mutatableContentCopy: IContentInfo[] = [];
    mutatableContentCopy = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, action.items);

    try {
      yield call(openSetContentOwnerDialog, mutatableContentCopy);
    } catch {
      return;
    }

    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, action.items);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openSetContentOwnerDialog(items: IContentInfo[]): ng.IPromise<IResult> {
  const setOwnerService = ServiceLocator.get<ChangeContentOwnerAction>('ChangeContentOwnerAction');
  const context = ServiceLocator.getAngularActionContext();
  return setOwnerService.confirmChangeOwner(items, context);
}

export function getUser(userId: string): ng.IPromise<IUserInfo> {
  return Users.instance.getById(userId);
}
